// ---------------------------------------------------------------------------
// Maps
// ---------------------------------------------------------------------------
/**
 * What an uploaded file is for. The kind decides which surface may show it,
 * so it is part of the contract rather than a server-private enum: the upload
 * UI has to name one, and a client copy of the list would drift.
 */
export const ASSET_KINDS = ['world_map', 'encounter_map', 'portrait'];
/**
 * `67` → `5 ft 7 in`: a height the way a person says it.
 *
 * **Shared because both sides say it**, and this project has already paid for a
 * byte-identical copy of `InventoryItem` living in two files. The sheet renders
 * it for a player and `sceneFacts` renders it for the model, so a divergence
 * would have one of them describing a character the other does not.
 *
 * Inches alone when there is no whole foot in the figure — a halfling's 34 is
 * not "2 ft 10 in" to anybody but a carpenter, and a bare number with no unit
 * at all is worse than an odd-looking one.
 */
export function feetAndInches(inches) {
    const feet = Math.floor(inches / 12);
    const rest = inches % 12;
    if (feet === 0)
        return `${rest} in`;
    return rest === 0 ? `${feet} ft` : `${feet} ft ${rest} in`;
}
//# sourceMappingURL=core.js.map